import React, { ReactNode } from 'react';

interface FormContainerProps {
  children: ReactNode;
  className?: string;
}
const FormContainer: React.FC<FormContainerProps> = ({
  children,
  className,
}) => {
  return (
    <section
      className={['grid grid-cols-1 md:grid-cols-2 gap-8', className].join(' ')}
    >
      {children}
    </section>
  );
};

export default FormContainer;
